export enum Shadow {
  SM = "0 .125rem .25rem rgba(0, 0, 0, 0.075)",
  MD = "0 .5rem 1rem rgba(0, 0, 0, 0.15)",
  LG = " 0 1rem 3rem rgba(0, 0, 0, 0.175)",
}
